import { render, staticRenderFns } from "./AxSidebar.vue?vue&type=template&id=4587f66c&"
import script from "./AxSidebar.vue?vue&type=script&lang=ts&"
export * from "./AxSidebar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/packages/axiom-design-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4587f66c')) {
      api.createRecord('4587f66c', component.options)
    } else {
      api.reload('4587f66c', component.options)
    }
    module.hot.accept("./AxSidebar.vue?vue&type=template&id=4587f66c&", function () {
      api.rerender('4587f66c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/04-web-components/powerbar/components/AxSidebar/AxSidebar.vue"
export default component.exports